import { Dispatch } from 'redux';
import { AppState } from '..';
import { playlistApi } from './api';
import { getPlaylistErrors } from './validation';
import { IPlaylist, PlaylistActionResult } from './types';

const normalizeItems = (playlist: IPlaylist): IPlaylist => ({
  ...playlist,
  items: playlist.items.map((item, index) => ({
    ...item,
    position: index,
  })),
});

export const addCreativityToPlaylist = (
  playlistId: string,
  creativityId: string
): PlaylistActionResult<Promise<IPlaylist | void>> => {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const playlist = getState().playlists.all.find(
      item => item._id === playlistId
    );

    if (!playlist || !creativityId) {
      return;
    }

    if (playlist.items.find(item => item.creativity === creativityId)) {
      return playlist;
    }

    const normalized = normalizeItems({
      ...playlist,
      items: [
        ...playlist.items,
        {
          creativity: creativityId,
          position: playlist.items.length,
        },
      ],
    });
    const errors = getPlaylistErrors(normalized, getState().creativities.all);

    if (errors.length) {
      dispatch({ type: 'PLAYLISTS/SAVE_FAILURE', error: errors });
      return;
    }

    dispatch({
      type: 'PLAYLISTS/UPDATE_DRAFT',
      id: playlistId,
      update: { items: normalized.items },
    });
    dispatch({ type: 'PLAYLISTS/SAVE_REQUEST' });

    try {
      const saved = await playlistApi.save(normalized);
      dispatch({ type: 'PLAYLISTS/SAVE_SUCCESS', data: saved });

      return saved;
    } catch (error) {
      dispatch({ type: 'PLAYLISTS/SAVE_FAILURE', error });
    }
  };
};

export const removeCreativityFromPlaylist = (
  playlistId: string,
  creativityId: string
): PlaylistActionResult<Promise<IPlaylist | void>> => {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const playlist = getState().playlists.all.find(
      item => item._id === playlistId
    );

    if (!playlist || !creativityId) {
      return;
    }

    if (!playlist.items.find(item => item.creativity === creativityId)) {
      return playlist;
    }

    const normalized = normalizeItems({
      ...playlist,
      items: playlist.items.filter(item => item.creativity !== creativityId),
    });
    const errors = getPlaylistErrors(normalized, getState().creativities.all);

    if (errors.length) {
      dispatch({ type: 'PLAYLISTS/SAVE_FAILURE', error: errors });
      return;
    }

    dispatch({
      type: 'PLAYLISTS/UPDATE_DRAFT',
      id: playlistId,
      update: { items: normalized.items },
    });
    dispatch({ type: 'PLAYLISTS/SAVE_REQUEST' });

    try {
      const saved = await playlistApi.save(normalized);
      dispatch({ type: 'PLAYLISTS/SAVE_SUCCESS', data: saved });

      return saved;
    } catch (error) {
      dispatch({ type: 'PLAYLISTS/SAVE_FAILURE', error });
    }
  };
};
